import { Chip, ChipProps, styled } from '@mui/material';
import { DateArg } from 'date-fns';
import { useTimer } from '../../hooks/useTimer';
import { formatTime } from '@razz-team/utils';

const StyledChip = styled(Chip)({
  fontFamily: 'monospace',
});

export type TimerChipProps = Omit<
  ChipProps<'div', { endsAt: DateArg<Date>; hideOnceEnded?: boolean }>,
  'label'
>;

export function TimerChip({ endsAt, hideOnceEnded, ...props }: TimerChipProps) {
  const timer = useTimer(endsAt);
  if (hideOnceEnded && timer <= 0) {
    return null;
  }

  return <StyledChip color="info" size="small" label={formatTime(timer)} {...props} />;
}
